import { render, staticRenderFns } from "./operation-board-handover-matter.vue?vue&type=template&id=fb901f50&scoped=true&"
import script from "./operation-board-handover-matter.vue?vue&type=script&lang=js&"
export * from "./operation-board-handover-matter.vue?vue&type=script&lang=js&"
import style0 from "./operation-board-handover-matter.vue?vue&type=style&index=0&id=fb901f50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb901f50",
  null
  
)

export default component.exports